<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">{{ $t('task.pageTitle') }}</h1>
      <ts-breadcrumb
        :items="[
          { text: $t('home'), href: '/' },
          {
            text: $t('task.pageTitle'),
            href: '/admin/tasks'
          },
          {
            text: $t('view'),
            active: true
          }
        ]"
      />
    </div>
    <ts-card>
      <ts-card-wrapper>
        <ts-loading-banner :loading="loading">
          <Tabs @on-click="onTabChange">
            <TabPane label="Detail" icon="ios-book" name="detail">
              <h2 class="ts-text-gray-800 ts-text-base">
                <i class="fas fa-briefcase ts-mr-3"></i>
                <span class="ts-font-khmer ts-font-robot"
                  >{{ resource.title }}
                </span>
                <a
                  href="#"
                  @click.prevent="onEdit"
                  class="ts-ml-3"
                  :title="$t('edit')"
                  ><Icon type="ios-create-outline" size="20"
                /></a>
              </h2>
  
              <p class="ts-mt-2 ts-pl-5">
                {{ resource.remarks }}
              </p>
  
              <h2 class="ts-text-gray-500 ts-text-base ts-capitalize">
                <i class="fas fa-book-reader ts-mr-3"></i> {{ $t('info') }}
              </h2>
              <TaskViewDetail :resource="resource" />
              <div class="ts-flex ts-space-x-3 ts-items-center ts-mt-6">
                <h2 class="ts-text-gray-500 ts-text-base ts-capitalize ts-mb-0">
                  <i class="fas fa-paperclip ts-mr-3"></i>
                  {{ $t('task.attachment') }}
                </h2>
                <button
                  @click.prevent="openBrowseFile"
                  class="ts-w-6 ts-h-6 ts-bg-blue-500 ts-rounded-full ts-flex ts-items-center ts-justify-center focus:ts-outline-none"
                >
                  <Icon type="ios-add" size="20" class="ts-text-white" />
                </button>
                <input type="file" ref="file" @change="addMoreAtt" />
              </div>
              <ViewAttachment :resource="resource" />
              <div class="ts-w-56" v-if="is_uploading">
                <Progress :percent="progressUploading" :stroke-width="10" />
              </div>
              <div class="ts-flex ts-space-x-3 ts-items-center ts-mt-6">
                <h2 class="ts-text-gray-500 ts-text-base ts-capitalize ts-mb-0">
                  <i class="fas fa-folder-open ts-mr-3"></i>
                  {{ $t('task.report') }}
                </h2>
                <button
                  @click.prevent="is_show_update_report = !is_show_update_report"
                  class="ts-w-6 ts-h-6 ts-bg-blue-500 ts-rounded-full ts-flex ts-items-center ts-justify-center focus:ts-outline-none"
                >
                  <Icon type="ios-add" size="20" class="ts-text-white" />
                </button>
                <input type="file" ref="file" @change="addMoreAtt" />
              </div>
              <div class="ts-h-2"></div>
              <div v-if="!is_show_update_report">
                <div v-for="(report, date) in reportList" :key="date">
                  <div class="ts-flex ts-justify-between">
                    <h1 class="ts-border-b ts-border-dashed ts-text-sm">
                      {{ date }}
                    </h1>
                    <button
                      @click.prevent="onShowProductDetail(date, report)"
                      class="ts-px-3 ts-py-1 ts-bg-gray-400 ts-rounded hover:ts-bg-gray-600 ts-transition-all ts-duration-150 hover:ts-text-white"
                    >
                      {{ $t('task.detail') }}
                    </button>
                  </div>
                  <div class="ts-pl-12 ts-p-2">
                    <table class="ts-w-full">
                      <thead>
                        <tr style="background-color: #f8f8f9">
                          <th class="ts-uppercase ts-text-sm ts-px-2 ts-w-1/4">
                            {{ $t('task.productName') }}
                          </th>
                          <th class="ts-uppercase ts-text-sm ts-px-2 ts-w-24">
                            {{ $t('task.uom') }}
                          </th>
                          <th class="ts-uppercase ts-text-sm ts-px-2 ts-w-12">
                            {{ $t('task.quantity') }}
                          </th>
                          <th class="ts-uppercase ts-text-sm ts-px-2">
                            {{ $t('task.remark') }}
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          v-for="(item, index) in report"
                          :key="index"
                          class="ts-border-b"
                        >
                          <td class=" ts-text-sm ts-px-2">
                            {{ item.product_name_en }}
                          </td>
                          <td class=" ts-text-sm ts-px-2">
                            {{ item.uom_name_en }}
                          </td>
                          <td class=" ts-text-sm ts-text-center ts-px-2">
                            {{ item.quantity }}
                          </td>
                          <td class=" ts-text-sm ts-px-2">
                            {{ item.remark }}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
              <TaskProfileMaterial v-else @cancel="onReport" @close="onReport" />
            </TabPane>
            <TabPane label="Comment" icon="md-book" name="comment">
              <!-- <Comment /> -->
              <div
                class="ts-flex ts-items-center ts-w-full ts-h-full ts-justify-center"
              >
                <img
                  class="ts-w-40 ts-object-contain"
                  src="https://t3.ftcdn.net/jpg/00/51/45/62/360_F_51456278_3y8SC99iozvWZZXfUdtJ21TlJaqgQHWK.jpg"
                  alt=""
                />
              </div>
            </TabPane>
            <TabPane label="Action Task" icon="ios-menu" name="worklog">
              <SubTaskTable v-if="active_tab === 'worklog'" />
            </TabPane>
            <TabPane label="History" icon="ios-clock" name="history"
              ><HistoryTab v-if="active_tab === 'history'"
            /></TabPane>
          </Tabs>
        </ts-loading-banner>
      </ts-card-wrapper>
    </ts-card>
    <Spin size="large" fix v-if="loading"></Spin>
    <a-modal
      v-if="show_product_detail"
      v-model="show_product_detail"
      title="Product Detail"
      :footer="null"
      width="75%"
      :zIndex="1024"
      :centered="true"
      @cancel="findTaskById($route.params.id)"
    >
      <viewProductDetailReport :reportDate="viewReportDate" />
    </a-modal>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import TaskViewDetail from './components/task-view-detail.vue'
import SubTaskTable from './components/sub-task-table.vue'
import ViewAttachment from './components/view-attachment.vue'
// import Comment from './components/task-comment/comment.vue'
import HistoryTab from './components/history-tab.vue'
import TaskProfileMaterial from './components/task-profile-material-report.vue'
import viewProductDetailReport from './components/view-product-detail-report.vue'
export default {
  components: {
    TaskViewDetail,
    ViewAttachment,
    SubTaskTable,
    // Comment,
    HistoryTab,
    TaskProfileMaterial,
    viewProductDetailReport
  },
  data() {
    return {
      loading: false,
      is_uploading: false,
      is_show_update_report: false,
      show_product_detail: false,
      viewReportDate: undefined,
      progressUploading: 0,
      active_tab: 'detail',
      resource: {},
      subTaskResources: []
    }
  },
  computed: {
    columns() {
      return [
        {
          title: this.$t('task.productName'),
          slot: 'title',
          sortable: true,
          minWidth: 200,
          className: 'ts-font-robot',
          fixed: 'left'
        },
        {
          title: this.$t('task.uom'),
          slot: 'title',
          sortable: true,
          width: 150,
          className: 'ts-font-robot',
          fixed: 'left'
        },
        {
          title: this.$t('task.quantity'),
          slot: 'title',
          sortable: true,
          width: 100,
          className: 'ts-font-robot',
          fixed: 'left'
        }
      ]
    },
    reportList() {
      if (this.resource.reports) {
        return this.resource.reports.reduce((acc, item) => {
          const { created_date, ...rest } = item
          if (acc[created_date]) {
            acc[created_date].push(rest)
          } else {
            acc[created_date] = [rest]
          }
          return acc
        }, {})
      }

      return []
    }
  },
  methods: {
    ...mapActions('projectMgt/taskProfile', [
      'preview',
      'addAttachments',
      'removeAttachments',
      'report'
    ]),
    onTabChange(tab) {
      this.active_tab = tab
    },
    findTaskById(id) {
      this.loading = true
      this.preview(id)
        .then(response => {
          this.resource = response.data
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => (this.loading = false))
    },
    openBrowseFile() {
      this.$refs.file.click()
    },
    addMoreAtt(event) {
      var config = {
        onUploadProgress: progressEvent => {
          this.progressUploading = Math.round(
            (progressEvent.loaded * 100) / progressEvent.total
          )
        }
      }
      let form = new FormData()
      form.append('file', event.target.files[0])
      this.is_uploading = true
      this.addAttachments({
        id: this.$route.params.id,
        data: form,
        config
      })
        .then(response => {
          this.resource.attachments.push(response.attachment)
        })
        .finally(() => (this.is_uploading = false))
    },
    onEdit() {
      this.$router.push({
        name: 'task-edit',
        params: {
          id: this.$route.params.id
        }
      })
    },
    onReport() {
      this.is_show_update_report = false
      this.findTaskById(this.$route.params.id)
    },
    onShowProductDetail(date) {
      this.show_product_detail = true
      this.viewReportDate = date
    }
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.findTaskById(to.params.id)
    })
  }
}
</script>
